(function () {
  /**
   * STORE LOCATOR — DOM REARRANGE
   *
   * Sposta dentro .show-addresses, in quest'ordine subito dopo .search_bar:
   *   1. .mobileControls
   *   2. .stores_filter
   * Inoltre sposta .search_filters (se rimasti in .search_bar) dentro .stores_filter.
   *
   * Idempotente: se gli elementi sono già nella posizione giusta, non fa nulla.
   */
  function rearrangeStoreLocator() {
    const row = document.querySelector('.stores__row');
    if (!row) return false;

    const showAddresses = row.querySelector(':scope > .show-addresses');
    if (!showAddresses) return false;

    const searchBar = showAddresses.querySelector(':scope > .search_bar');

    // Sposta .stores_filter (se ancora in .stores__row) subito dopo .search_bar
    const storesFilter = row.querySelector(':scope > .stores_filter');
    if (storesFilter && !showAddresses.contains(storesFilter)) {
      if (searchBar) {
        searchBar.insertAdjacentElement('afterend', storesFilter);
      } else {
        showAddresses.insertBefore(storesFilter, showAddresses.firstChild);
      }
    }

    // Sposta .mobileControls (se ancora in .stores__row) subito dopo .search_bar
    const mobileControls = row.querySelector(':scope > .mobileControls');
    if (mobileControls && !showAddresses.contains(mobileControls)) {
      if (searchBar) {
        searchBar.insertAdjacentElement('afterend', mobileControls);
      } else {
        showAddresses.insertBefore(mobileControls, showAddresses.firstChild);
      }
    }

    // Sposta .search_filters dentro .stores_filter (se ancora orfani in .search_bar)
    const targetFilter =
      showAddresses.querySelector(':scope > .stores_filter') ||
      row.querySelector(':scope > .stores_filter');
    const searchFilters = document.querySelector('.search_bar > .search_filters');
    if (searchFilters && targetFilter && !targetFilter.contains(searchFilters)) {
      targetFilter.appendChild(searchFilters);
    }

    // Considera fatto se tutto è al suo posto
    const filtersOk =
      !searchFilters ||
      (targetFilter && targetFilter.contains(searchFilters));
    const filterOk =
      !storesFilter || showAddresses.contains(storesFilter);
    const controlsOk =
      !mobileControls || showAddresses.contains(mobileControls);

    return filtersOk && filterOk && controlsOk;
  }

  // Tentativo immediato
  if (!rearrangeStoreLocator()) {
    let n = 0;
    const iv = setInterval(() => {
      if (rearrangeStoreLocator() || ++n > 30) clearInterval(iv);
    }, 200);
  }

  document.addEventListener('DOMContentLoaded', rearrangeStoreLocator);
  window.addEventListener('load', rearrangeStoreLocator);
})();
